import { Skeleton } from '@sib/ui';

export const TicketDetailsSkeleton = () => (
  <>
    <Skeleton className="h-11 w-full" />
    <Skeleton className="h-24 w-full" />
    <Skeleton className="h-56 p-0" />
  </>
);
